export abstract class NavigationMenuRoute {
  public readonly routeName?: string;
  public readonly routePath?: string;
}
